import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';

const RecoveryPortalContext = createContext(null);
const API_URL = process.env.REACT_APP_BACKEND_URL;

const FALLBACK = {
    portal_name: 'Cybernetics Recovery',
    tagline: "Lost crypto isn't always gone.",
    hero_title: 'Assets Recovery Program',
    hero_subtitle: '',
    accent_color: '#F5B841',
    secondary_color: '#0E7C7B',
    logo_url: '/logo.jpg',
    sections: {},
    stats: {},
    methods: [],
    faq: [],
    stage_templates: [],
};

export const RecoveryPortalProvider = ({ children }) => {
    const [config, setConfig] = useState(FALLBACK);
    const [loaded, setLoaded] = useState(false);

    const refresh = useCallback(async () => {
        try {
            const res = await axios.get(`${API_URL}/api/recovery/portal-config`, { timeout: 10000 });
            setConfig({ ...FALLBACK, ...res.data });
        } catch (e) {
            // keep fallback
        } finally {
            setLoaded(true);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const themeStyle = {
        '--rp-accent': config.accent_color || FALLBACK.accent_color,
        '--rp-secondary': config.secondary_color || FALLBACK.secondary_color,
    };

    return (
        <RecoveryPortalContext.Provider value={{ config, loaded, refresh, themeStyle, setConfig }}>
            {children}
        </RecoveryPortalContext.Provider>
    );
};

export const useRecoveryPortal = () => {
    const ctx = useContext(RecoveryPortalContext);
    if (!ctx) throw new Error('useRecoveryPortal must be used within RecoveryPortalProvider');
    return ctx;
};
